import React from "react";
import { useQuery } from "@tanstack/react-query";
import api from "@/lib/api";
import { shortDate } from "@/lib/format";
import { Scroll as ScrollText } from "@phosphor-icons/react";

export default function AdminAudit() {
  const { data } = useQuery({ queryKey: ["audit"], queryFn: async () => (await api.get("/admin/audit-logs")).data });
  const logs = data?.logs || [];

  return (
    <div className="space-y-6">
      <div>
        <h1 className="font-display text-3xl font-semibold tracking-tight">Audit Logs</h1>
        <p className="mt-1 text-sm text-muted-foreground">Immutable trail of every actor action across the platform.</p>
      </div>

      <div className="overflow-hidden rounded-lg border border-white/10 bg-card">
        {logs.map((l, i) => (
          <div key={i} data-testid={`audit-${i}`} className="flex items-center gap-3 border-b border-white/5 px-4 py-3 text-sm last:border-0">
            <div className="flex h-8 w-8 items-center justify-center rounded-md bg-white/5 text-muted-foreground"><ScrollText size={16} /></div>
            <div className="min-w-0 flex-1">
              <p className="truncate"><span className="font-mono-metric text-xs text-primary">{l.action}</span> · {l.entity_type}</p>
              <p className="truncate text-xs text-muted-foreground">{l.actor_email}{l.entity_id ? ` · ${l.entity_id}` : ""}</p>
            </div>
            <span className="whitespace-nowrap text-xs text-muted-foreground">{shortDate(l.created_at)}</span>
          </div>
        ))}
        {logs.length === 0 && <p className="px-4 py-10 text-center text-sm text-muted-foreground">No audit entries</p>}
      </div>
    </div>
  );
}
